import { authFetch } from '@/lib/auth/authFetch';
import { API_BASE_URL } from '@/utils/api';
import logger from '@/utils/logger';

const API_URL = `${API_BASE_URL}/fan-profile`;

async function listProfile(userID, accessToken) {
  logger.debug('Fetching profile', { userID });
  try {
    const response = await authFetch(`${API_URL}/profile/${userID}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    logger.debug('Profile data received');
    return {
      statusCode: 200,
      body: data,
    };
  } catch (error) {
    logger.error(error);
    return {
      statusCode: 500,
      body: { error: 'Failed to list profile' },
    };
  }
}

async function editSocials(userID, tiktokHandle, instagramHandle, accessToken) {
  try {
    const response = await authFetch(`${API_URL}/socials`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        userID,
        tiktokHandle,
        instagramHandle,
      }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return {
      statusCode: 200,
      body: data,
    };
  } catch (error) {
    logger.error(error);
    return {
      statusCode: 500,
      body: { error: 'Failed to edit socials' },
    };
  }
}

async function updateAddressInfo(userID, zipCode, phoneNumber, defaultAddress, accessToken) {
  try {
    const response = await authFetch(`${API_URL}/address-info`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        userID,
        zipCode,
        phoneNumber,
        defaultAddress,
      }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return {
      statusCode: 200,
      body: data,
    };
  } catch (error) {
    logger.error(error);
    return {
      statusCode: 500,
      body: { error: 'Failed to update address info' },
    };
  }
}

async function modifyTextPreferences(userID, preference, accessToken) {
  if (preference === true) {
    preference = 1;
  } else {
    preference = 0;
  }
  try {
    const response = await authFetch(`${API_URL}/text-preferences`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        userID,
        preference,
      }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return {
      statusCode: 200,
      body: data,
    };
  } catch (error) {
    logger.error(error);
    return {
      statusCode: 500,
      body: { error: 'Failed to modify text preferences' },
    };
  }
}

async function getFirstTimeSignUp(userID, accessToken) {
  try {
    const response = await authFetch(`${API_URL}/first-time-signup/${userID}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return {
      statusCode: 200,
      body: data,
    };
  } catch (error) {
    logger.error(error);
    return {
      statusCode: 500,
      body: { error: 'Failed to get first time sign up' },
    };
  }
}

async function createEnrichment(userID, mapID, value, brandID, accessToken) {
  try {
    const response = await authFetch(`${API_URL}/create-enrichment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        userID,
        mapID,
        value,
        brandID,
      }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return {
      statusCode: 200,
      body: data,
    };
  } catch (error) {
    logger.error(error);
    return {
      statusCode: 500,
      body: { error: 'Failed to create enrichment data' },
    };
  }
}

async function verifyUserNullSubmission(userID, missionID, accessToken) {
  try {
    const response = await authFetch(`${API_URL}/verify-user-null-submission/${userID}/${missionID}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return {
      statusCode: 200,
      body: data,
    };
  } catch (error) {
    logger.error(error);
    return {
      statusCode: 500,
      body: { error: 'Failed to verify user null submission' },
    };
  }
}

export {
  createEnrichment,
  editSocials,
  getFirstTimeSignUp,
  listProfile,
  modifyTextPreferences,
  updateAddressInfo,
  verifyUserNullSubmission,
};

export default async function handler(req, res) {
  if (req.method === 'POST') {
    try {
      const { userID, zipCode, phoneNumber, defaultAddress } = req.body;
      const accessToken = req.headers.authorization; // Get the token from the Authorization header

      if (!accessToken) {
        return res.status(401).json({ error: 'Authorization token is required' });
      }

      const result = await updateAddressInfo(userID, zipCode, phoneNumber, defaultAddress, accessToken);

      res.status(result.statusCode).json(result.body);
    } catch (error) {
      logger.error(error);
      res.status(500).json({ error: 'Internal server error' });
    }
  } else {
    res.status(405).json({ error: 'Method not allowed' });
  }
}
